import { createI18n } from 'vue-i18n'
import en from '@/locale/en.json'

// Vue.use(VueI18n);

const languages = {
  en: en,
}

export const i18n = createI18n({
  locale: 'en_US', // default locale
  messages: languages, // set locale messages
  fallbackLocale: 'en',
  silentFallbackWarn: false,
  allowComposition: true,
  pluralizationRules: {
    /**
     * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
     * @param choicesLength {number} an overall amount of available choices
     * @returns a final choice index to select plural word by
     */
    //https://developer.mozilla.org/en-US/docs/Mozilla/Localization/Localization_and_Plurals#list_of_plural_rules

    pl: function (choice, choicesLength) {
      if (choice === 1) {
        return 0
      }
      const teen = choice > 10 && choice < 20

      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 1
      }

      if (choicesLength > 2) return 2
      else return 1
    },
    ru: function (choice, choicesLength) {
      // this === VueI18n instance, so the locale property also exists here

      if (choice === 0) {
        return 0
      }

      const teen = choice > 10 && choice < 20
      const endsWithOne = choice % 10 === 1

      if (choicesLength < 4) {
        return !teen && endsWithOne ? 1 : 2
      }
      if (!teen && endsWithOne) {
        return 1
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2
      }

      return choicesLength < 4 ? 2 : 3
    },
  },
})
